import Marquee from "react-fast-marquee";

const words = [
  "शिक्षा",
  "Fluency",
  "व्याकरण",
  "Confidence",
  "साहित्य",
  "Careers",
  "उच्चारण",
  "Exams",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="py-10 border-y border-border bg-background overflow-hidden"
    >
      <Marquee speed={38} gradient={false}>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-editorial italic text-5xl md:text-7xl text-foreground/90 px-8">
              {w}
            </span>
            <span className="font-deva text-3xl md:text-4xl text-primary px-2">
              ·
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
